import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface BulkUnarchivePackagesRequest {
  ids: number[]
}

export const bulkUnarchivePackages = async (data: BulkUnarchivePackagesRequest): Promise<void> => {
  await authAPI.put('/packages/bulk-unarchive', data)
}

export const useBulkUnarchivePackages = () => {
  return useMutation({
    mutationFn: bulkUnarchivePackages,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
